import React, { ReactNode } from "react";

import { SplitBlock as Value } from "@reactivated";

import { HeroLayoutSettings } from "@thelabnyc/thelabui/src/components/Flexihero/HeroLayout.interfaces";
import { HeroSet } from "@thelabnyc/thelabui/src/components/Flexihero/HeroSet";

import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface Props {
    media: ReactNode | null;
    content: ReactNode | null;
    contentAlignment: Value["content_alignment"];
}

const Split = ({ content, media, contentAlignment }: Props) => {
    const sharedStyles = {
        contentClassName: styles.content,
        // static name to hook into for interblock styling
        rootClassName: "splitBlockGlobal",
    };

    const settings: HeroLayoutSettings = {
        heroDirection: "row",
        heroPlacement: "full",
        mediaPlacement: "inline",
        mediaAspectRatio: "1:1",
        contentAlignPrimary: "middle",
        contentAlignSecondary:
            contentAlignment === "left" ? "left/top" : "right/bottom",
        textAlignment: "left",
        contentWidth: 6,
    };

    return (
        <HeroSet
            layouts={{
                desktop: {
                    content,
                    media,
                    settings,
                    styles: sharedStyles,
                },
                mobile: {
                    content,
                    media,
                    settings: {
                        ...settings,
                        heroDirection: "column",
                        contentAlignSecondary: "right/bottom",
                        contentWidth: 12,
                        textAlignment: "center",
                    },
                    styles: sharedStyles,
                },
            }}
        />
    );
};

export const SplitBlock = ({ value }: { value: Value }) => {
    return (
        <Split
            content={value.content ? <RichText value={value.content} /> : null}
            media={value.media && <MediaChooserBlock value={value.media} />}
            contentAlignment={value.content_alignment}
        />
    );
};
